import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, FormControl, Form } from '@angular/forms';
import { RosterValidatorService } from './roster-validator.service'
import { IWorker } from '../Interfaces/worker';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Injectable()
export class RosterFormService {
  public form: FormGroup;
 
  constructor(private fb: FormBuilder, private rosterValidatorService: RosterValidatorService) {
    this.form = this.fb.group({
      Meeting: this.fb.group({
        WorkSite: [null,Validators.required],
        MeetingType: [null, Validators.required],
        MeetingDate: [new Date(), null],
        Note: [null, null],
        MeetingTitle: [null, null],
        WorksiteId: [null, null],
        OrganiserId: [null, null]
      }),
      Roster: this.fb.array([]),
      NewContacts : this.fb.array([]),
      SelectAll : [false,null]

    }, { validators: null //this.rosterValidatorService.formValidator() 
    });
  }
  get rosterArray(): FormArray {
    return this.form.get('Roster') as FormArray;
  }
  get newContactsArray(): FormArray {
    return this.form.get('NewContacts') as FormArray;
  }
  get formBuilder(): FormBuilder {
    return this.fb;
  }

  get isValid(): boolean {
    this.rosterValidatorService.validateAllFormFields(this.form);
    if (!this.form.valid) {  
         return false;
    }

    return true;
  }

  
  public set Roster(arr : Array<IWorker>) {
    arr.forEach(worker => {
      let group: any = {};
      group["isSelected"] = new FormControl(worker.isSelected);
      group["id"] = new FormControl(worker.id);
      group["memberType"] = new FormControl(worker.memberType);
      group["firstName"] = new FormControl(worker.firstName);
      group["middleName"] = new FormControl(worker.middleName);
      group["lastName"] = new FormControl(worker.lastName);  
      group["mobilePhone"] = new FormControl(worker.mobilePhone);   
      group["email"] = new FormControl(worker.email);   
      group["workPhone"] = new FormControl(worker.workPhone);  
      group["status"] = new FormControl(worker.status);
      this.rosterArray.push(new FormGroup(group));
      group = {};
    });
  
  }
  public set NewContacts(arr : Array<IWorker>) {
    arr.forEach(worker => {
      let group: any = {};
      group["isSelected"] = new FormControl(worker.isSelected);
      group["id"] = new FormControl(worker.id);
      group["memberType"] = new FormControl(worker.memberType);
      group["firstName"] = new FormControl(worker.firstName);
      group["middleName"] = new FormControl(worker.middleName);
      group["lastName"] = new FormControl(worker.lastName);  
      group["mobilePhone"] = new FormControl(worker.mobilePhone);   
      group["email"] = new FormControl(worker.email);   
      group["workPhone"] = new FormControl(worker.workPhone);  
      group["status"] = new FormControl(worker.status);
      this.newContactsArray.push(new FormGroup(group));
      group = {};
    });
  
  }

//   RosterFilteredList(filter:string) : any {
//   return this.rosterArray.valueChanges.pipe(
//     map(value=>{
      
//         if (value.status === '') {
//           return value.properties.map((p, index) => ({ ...p, index }));
//         }     
//         return value.properties.filter(p => p.key.toLowerCase().includes(filter) || p.value.toLowerCase().includes(filter)).map(p => ({ ...p, index: value.properties.indexOf(p) }));
      
//       }));
// }
  
}
